/* eslint-disable react/display-name */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  NavLink
} from "reactstrap";

import ReactTable, { ReactTableDefaults } from "react-table";
import "react-table/react-table.css";

import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";

import PesquisaRapida from "../Common/PesquisaRapida";
import PrettyCheckbox from "../Common/PrettyCheckbox";
import TooltippedCel from "../Common/TooltippedCel";
import Pagination from "../../Util/Pagination";
import DocumentosFiscaisSubComponent from "../Common/DocumentosFiscaisSubComponent";
import InputMask from "react-input-mask";

import { AlertasContext } from "../../Providers/Alertas";
import { BlockUiContext } from "../../Providers/BlockUi";

import ImpressoesDetalhes from "../Modais/ImpressoesDetalhes";
import EmissoesExclusao from "../Modais/EmissoesExclusao";
import EmissoesExclusaoTodos from "../Modais/EmissoesExclusaoTodos";
import ErroImpressaoGuiasEmitidas from "../Modais/ErroImpressaoGuiasEmitidas";
import EmissoesES from "../Modais/EmissoesES";
import RemessaBancaria from "../Modais/RemessaBancaria";
import DesmarcarComoPaga from "../Modais/DesmarcarComoPaga";
import RemessaBancariaAvisoSelecionarTodas from "../Modais/RemessaBancariaAvisoSelecionarTodas";
import AvisoSelecionarTodas from "../Modais/AvisoSelecionarTodas";

import { getVal, formataCurrency, formataData } from "../../BaseFunctions";

import { LogsServiceAPI } from "../../Util/logsService";
import Cookies from "js-cookie";

import "./Emitidas.scss";
import infoImg from "../../Assets/information.jpg";

const isSimulacao = localStorage.getItem("isSimulacao") === "true";
const isPro = localStorage.getItem("isPro") === "true";

const getStoredPageSize = () => {
  const stored = localStorage.getItem("gnre_pageSize");
  return stored ? parseInt(stored) : 20;
};

Object.assign(ReactTableDefaults, {
  pageSizeOptions: [20, 25, 50, 100],
  defaultPageSize: 20,
  pageSize: 20,
  minRows: 20,
  // maxRows: 30,
  nextText: "Próxima",
  previousText: "Anterior",
  noDataText: "Nenhum resultado encontrado",
  pageText: "Pág.",
  ofText: "de",
  rowsText: "linhas",
  resizable: true
});

function Emitidas() {
  const [rawData, setRawData] = useState([]);
  const [showData, setShowData] = useState([]);
  const [showDataPagination, setShowDataPagination] = useState([]);
  const [rawDocs, setRawDocs] = useState([]);
  const [rawDocsValorTotal, setRawDocsValorTotal] = useState([]);
  const [rawDocsReceita, setRawDocsReceita] = useState([]);
  const [rawDocsDestinatario, setRawDocsDestinatario] = useState([]);
  const [rawDocsVlPrincipal, setRawDocsVlPrincipal] = useState([]);
  const defaultSorted = [{ id: "intNFE", desc: false }];
  const [detalhes, setDetalhes] = useState({});
  const [strBusca, setStrBusca] = useState("");
  const [blFiltroAtivo, setBlFiltroAtivo] = useState(false);
  const [blShowPesquisaRapida, setBlShowPesquisaRapida] = useState(false);
  const [seES, setSeES] = useState(false);
  const [erroImpressao, setErroImpressao] = useState([]);
  const [urlHomo, setUrlHomo] = useState("");
  const [pageData, setDataPage] = useState("");
  const [valueRemessa, setValueRemessa] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ sortBy: '', sortDirection: 'asc' });
  const [filterEmitente, setFilterEmitente] = useState('');
  const [filterUf, setFilterUf] = useState('');
  const [filterBusca, setFilterBusca] = useState('');
  const [filterData, setFilterData] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [allSelectedIds, setAllSelectedIds] = useState([]);
  const [pageSize, setPageSize] = useState(getStoredPageSize());
  const debounceTimer = useRef(null);

  let reactTable = React.createRef();
  let ModalDetalhes = React.createRef();
  let ModalEmissoesExclusao = React.createRef();
  let ModalErroImpressao = React.createRef();
  let ModalImpressaoES = React.createRef();
  let ModalEmissoesExclusaoTodos = React.createRef();
  const ModalRemessaBancaria = useRef(null);
  let ModalDesmarcarComoPaga = React.createRef();
  let ModalRemessaBancariaAvisoSelecionarTodas = React.createRef();
  let ModalAvisoSelecionarTodas = React.createRef();

  /* eslint-disable no-unused-vars */
  let onLoading;
  let showInfoMessage;
  let showSuccessMessage;
  let showWarningMessage;
  let showErrorMessage;
  let todasMarcadas = useMemo(() => {
    return showData.every((data) => data.blSelected)
  },[showData]);
  /* eslint-enable no-unused-vars */

  useEffect(() => {
    handleReload();
    const notificar = localStorage.getItem("notificarImpressao");
    if (notificar === "true") {
      showSuccessMessage("Guias emitidas com sucesso!");
    }
    localStorage.setItem("notificarImpressao", false);

    if (
      window.location.hostname == "ec2-34-206-89-100.compute-1.amazonaws.com"
    ) {
      setUrlHomo(
        "http://www.testegnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp"
      );
    } else {
      setUrlHomo(
        "http://www.gnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp"
      );
    }
  }, []);

  const handleReload = (page = 1, overrideFilters = {}) => {
    onLoading(true);

    const params = new URLSearchParams({
      page: page,
      pageSize: overrideFilters.pageSize !== undefined ? overrideFilters.pageSize : pageSize,
      sortBy: overrideFilters.sortBy !== undefined ? overrideFilters.sortBy : sortConfig.sortBy,
      sortDirection: overrideFilters.sortDirection !== undefined ? overrideFilters.sortDirection : sortConfig.sortDirection,
      filterEmitente: overrideFilters.filterEmitente !== undefined ? overrideFilters.filterEmitente : filterEmitente,
      filterUf: overrideFilters.filterUf !== undefined ? overrideFilters.filterUf : filterUf,
      filterBusca: overrideFilters.filterBusca !== undefined ? overrideFilters.filterBusca : filterBusca,
      filterData: overrideFilters.filterData !== undefined ? overrideFilters.filterData : filterData,
      filterStatus: overrideFilters.filterStatus !== undefined ? overrideFilters.filterStatus : filterStatus
    });

    HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarEmitidasPaginado?${params}`)
      .then(response => {
        onLoading(false);
        const { data } = response;

        const rawData = data.Items.map(original => ({
          ...original,
          valor: original.valorTotal,
          blSelected: false
        }));
        setRawData(rawData);
        setShowData(rawData);
        setShowDataPagination(rawData);
        setTotalCount(data.TotalCount);
        setCurrentPage(data.Page);
      })
      .catch(() => {
        onLoading(false);
        showErrorMessage("Erro ao carregar dados");
        setRawData([]);
        setShowData([]);
      });
  };

  const onUpdatePesquisaRapida = (data, strBuscaValue, blShow) => {
    setStrBusca(strBuscaValue);
    setBlShowPesquisaRapida(blShow);
    setFilterBusca(strBuscaValue);
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      handleReload(1, { filterBusca: strBuscaValue });
    }, 500);
  };
  
  const textFilterMethod = (filter, row) =>
    row[filter.id] &&
    row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;

  const textFilterSituacao = (filter, row) => {
    if (filter.value.toLowerCase() == "impresso") {
      return (
        row[filter.id] &&
        row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1
      );
    }

    if (filter.value.toLowerCase() == "não impresso") {
      let teste = "Sucesso";
      return (
        row[filter.id] &&
        row[filter.id].toLowerCase().indexOf(teste.toLowerCase()) > -1
      );
    }
  };

  const SelecionarTodasGuias = () => {
    onLoading(true);
    const params = new URLSearchParams({
      filterEmitente: filterEmitente,
      filterUf: filterUf,
      filterBusca: filterBusca
    });

    HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarIdsEmitidas?${params}`)
      .then(response => {
        onLoading(false);
        setAllSelectedIds(response.data);
        const newShowData = showData.map(data => ({...data, blSelected: true}));
        setShowData(newShowData);
      })
      .catch(() => {
        onLoading(false);
      });
  };

  const DesmarcarTodasGuias = () => {
    setAllSelectedIds([]);
    const newShowData = showData.map(data => ({...data, blSelected: false}));
    setShowData(newShowData);
  };

  const acaoBotaoSelecionardesmarcrTodas = () => {
    if(todasMarcadas)
    {
      DesmarcarTodasGuias();
    }
    else{
      ModalAvisoSelecionarTodas.current.openModal();
    }
  }

  const dateFilterMethod = (filter, row) =>
    row[filter.id] &&
    new Date(row[filter.id]).toLocaleDateString().indexOf(filter.value) > -1;

  const childPaginationValue = page => {
    setDataPage(page);
  };

  const handleTableSelectAllChange = ({ target: { checked } }) => {
    setAllSelectedIds([]);
    const firstPageIndex = (pageData - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    const dadosLista = showData.slice(firstPageIndex, lastPageIndex);

    let listaPaginada = dadosLista.map(original => ({
      ...original,
      blSelected: checked
    }));

    const valor = rawData.map(row => {
      listaPaginada.map(el => {
        if (row.id == el.id) {
          row.blSelected = el.blSelected;
        }
      });
      return row;
    });

    setShowDataPagination(valor);
    setShowData(valor);

    setShowDataPagination(
      valor.map(original => ({ ...original, blSelected: checked }))
    );
  };

  const handleTableSelectChange = (row, target) => {
    setAllSelectedIds([]);
    const newShowData = [
      ...showData.slice(0, row.index),
      { ...row.original, [target.name]: target.checked },
      ...showData.slice(row.index + 1)
    ];
    
    setShowData(newShowData);
    
    setValueRemessa(newShowData.filter(x => x.blSelected));
    console.log(newShowData.filter(x => x.blSelected));
  };

  const logImpressao = () => {
    // Pega log ao imprimir a guia e envia para o Painel de Acessos do Principal
    let logsServiceApi = new LogsServiceAPI();
    logsServiceApi.salvarLog(Cookies.get("bG9naW4"), 353, 3);
  };

  const imprimirSelecionadas = (id = null) => {
    onLoading(true);
    logImpressao();
    if (id != null && id.uf == "ES" && seES == false) {
      ModalImpressaoES.current.openModal();
      setSeES(true);
    } else {
      setSeES(false);
    }
    const selected =
      id != null ? [id.id] : (allSelectedIds.length > 0 ? allSelectedIds : showData.filter(x => x.blSelected).map(x => x.id));

    if (selected != null) {
      HttpUtil.eco_POST_CONFIG(
        `${Config.urls.API_URL_BASE}Documento/ImprimirAsync`,
        selected,
        {
          responseType: "blob",
          headers: {
            Authorization: `bearer ${localStorage.getItem("AccessToken")}`
          }
        }
      )
        .then(response => {
          const warnings = response.headers["x-print-warnings"];
          if (warnings) {
            try {
              setErroImpressao(JSON.parse(warnings));
            } catch (e) {
              setErroImpressao([warnings]);
            }
          }
          const file = new Blob([response.data], { type: "application/pdf" });
          onLoading(false);
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          handleReload();
        })
        .catch((error) => {
          onLoading(false);
          if (error.response && error.response.status === 400) {
            ModalErroImpressao.current.openModal();
          } else {
            showErrorMessage("Ocorreu um erro ao obter o pdf da receita");
          }
        });
    }
  };

  useEffect(() => {
    if (erroImpressao.length > 0) {
      ModalErroImpressao.current.openModal();
    }
  }, [erroImpressao]);

  useEffect(() => {
    detalhes.id && ModalDetalhes.current.openModal();
  }, [detalhes]);

  const onAcceptSelected = (dados)=> {
    console.log(dados);
    setValueRemessa(dados);
    ModalRemessaBancaria.current.openModal();
  };

  const MostrarModalDetalhes = (id, recibo, status) => {
    onLoading(true);

    var url = `${Config.urls.API_URL_BASE}Documento/BuscarDetalhes/${id}`;

    HttpUtil.eco_GET(url).then(response => {
      setDetalhes({ guias: [] });

      if (response.data.length > 0) {
        setDetalhes({
          id: id,
          razaoSocial: response.data[0].razaoSocial,
          documento: response.data[0].documentoDestinatario,
          guias: response.data,
          status
        });
        onLoading(false);
      }
    });
  };

  const validarShowRemessaBancaria = showData => {
    if (showData.length > 1) {
      let cnpj = showData.map(a => a.cnpjEmissor);
      let status = showData.map(a => a.status);
      let controle = false;
      cnpj.forEach(item => {
        if (item != cnpj[0]) {
          controle = true;
        }
      });
      status.forEach(item => {
        if (item === "ArquivoGerado" || item === "Paga") {
          controle = true;
        }
      });
      return controle;
    }
    return true;
  };

  const mostrarDestacados = (row, valor, tooltip = false) => {
    let newValor = valor;
    switch (valor) {
      case "Sucesso":
        newValor = "Não Impresso";
        break;
      case "ArquivoGerado":
        newValor = "Arquivo Gerado";
        break;
    }
    return (
      <div
        className={`row-mostrar-destacados ${
          row.original.status === "Sucesso" ? "sucesso" : ""
        }`}
      >
        {tooltip ? <TooltippedCel text={newValor} /> : newValor}
      </div>
    );
  };

  const alternarPagamento = ({ id, uf, estaPago, motivo }) => {
    // Lida com IDs negativos
    if (id < 0) {
      id *= -1;
    }
    //
    onLoading(true);
    HttpUtil.eco_PUT(
      `${Config.urls.API_URL_BASE}Documento/Guia/PagamentoStatus`,
      {
        idDocumento: id,
        uf: uf,
        flagPago: !estaPago,
        motivo: motivo || null
      }
    )
      .then(() => {
        onLoading(false);
        handleReload();
      })
      .catch(() => {
        onLoading(false);
      });
  };

  const lidarComAlteracaoPagamento = ({ id, uf, estaPago }) => {
    if (!estaPago) {
      alternarPagamento({ id, uf, estaPago });
      return;
    }
    if (ModalDesmarcarComoPaga.current) {
      ModalDesmarcarComoPaga.current.abrirModal({ id, uf, estaPago });
    }
  };

  const imprimirFiltro = () => {
    const notNullid = showData.filter(x => x.blSelected).map(x => x.uf);
    for (const uf of notNullid) {
      if (uf == "ES" && !seES) {
        ModalImpressaoES.current.openModal();
        setSeES(true);
      }
    }
    imprimirSelecionadas();
  };

  const habilitarImpressao = row => (
    <Row>
      {row.original.status !== "Paga" && (
        <Col
          className="nav-item m-0"
          onClick={() => imprimirSelecionadas(row.original)}
        >
          <span id={"printTip" + row.original.id}>
            <i className="fas fa-print" />
          </span>
          <UncontrolledTooltip
            placement="top"
            target={"printTip" + row.original.id}
          >
            Imprimir
          </UncontrolledTooltip>
        </Col>
      )}
      <Col
        className="nav-item m-0"
        onClick={() =>
          MostrarModalDetalhes(
            row.original.id,
            row.original.recibo,
            row.original.status
          )
        }
      >
        <span id={"detailTip" + row.original.id}>
          <i className="fas fa-file-alt" />
        </span>
        <UncontrolledTooltip
          placement="top"
          target={"detailTip" + row.original.id}
        >
          Detalhes
        </UncontrolledTooltip>
      </Col>
      {row.original.status !== "Sucesso" && (
        <Col
          className="nav-item m-0"
          onClick={() =>
            lidarComAlteracaoPagamento({
              id: row.original.id,
              uf: row.original.uf,
              estaPago: row.original.status === "Paga"
            })
          }
        >
          <span
            id={`check-${row.original.id}`}
            className={`${row.original.status === "Paga" ? "marcarPaga" : ""}`}
          >
            <i className="fas fa-check-square" />
          </span>
          <UncontrolledTooltip
            placement="top"
            target={`check-${row.original.id}`}
          >
            {row.original.status === "Paga"
              ? "Desmarcar como paga"
              : "Marcar como paga"}
          </UncontrolledTooltip>
        </Col>
      )}
    </Row>
  );

  const renderDocumentosFiscais = row => (
    <DocumentosFiscaisSubComponent idGuia={row.original.id} showAtualizacao={true} />
  );

  const columns = [
    {
      Header: () => <div />,
      expander: true,
      // eslint-disable-next-line react/prop-types
      Expander: ({ isExpanded }) => (
        <div>
          {isExpanded ? (
            <i className="fas fa-minus" />
          ) : (
            <i className="fas fa-plus" />
          )}
        </div>
      )
    },
    {
      Header: () => (
        <div className="text-center">
          <PrettyCheckbox
            strTitle="Essa opção seleciona todos os documentos existentes nesse grupo e não somente a quantidade exibida."
            checked={showDataPagination.every(original => original.blSelected)}
            id="selectAll"
            onChange={e => handleTableSelectAllChange(e)}
            // onChange={() => toggleAllPageRowsSelected()}
            iconSuccess="fas fa-check-double"
            simpleSelection
          />
        </div>
      ),
      accessor: "blSelected",
      Cell: row => (
        <PrettyCheckbox
          strTitle="Selecionar"
          checked={row.original.blSelected}
          id="blSelected"
          onChange={({ target }) => handleTableSelectChange(row, target)}
          iconSuccess="fas fa-check"
          simpleSelection
        />
      ),
      filterable: false,
      sortable: false,
      className: "text-center",
      width: 35
    },
    {
      Header: () => <div className="text-left">Emitente</div>,
      accessor: "razaoSocialEmissor",
      filterMethod: textFilterMethod,
      className: "text-left",
      Cell: row => mostrarDestacados(row, row.value, true)
    },
    {
      Header: "Pagamento",
      accessor: "data",
      className: "text-center",
      Cell: row => mostrarDestacados(row, formataData(row.value), false),
      width: 140,
      Filter: ({ filter, onChange }) => (
        <input
          type="date"
          value={filter ? filter.value : ""}
          onChange={e => onChange(e.target.value)}
          style={{ width: "100%" }}
        />
      )
    },
    {
      Header: "UF DESTINO",
      accessor: "uf",
      filterMethod: textFilterMethod,
      className: "text-center",
      width: 100
    },
    {
      Header: "Valor",
      accessor: "valorTotal",
      filterMethod: (filter, row) =>
        row[filter.id] && row[filter.id].toString().includes(filter.value),
      className: "text-center",
      width: 100,
      Cell: row => mostrarDestacados(row, formataCurrency(row.value))
    },
    {
      Header: "Situação",
      accessor: "status",
      className: "text-center",
      width: 150,
      Cell: row => mostrarDestacados(row, row.value),
      Filter: ({ filter, onChange }) => (
        <select
          onChange={e => onChange(e.target.value)}
          value={filter ? filter.value : ""}
          style={{ width: "100%" }}
        >
          <option value="">Todas</option>
          <option value="Não Impresso">Não Impresso</option>
          <option value="Impresso">Impresso</option>
          <option value="Arquivada">Arquivada</option>
          <option value="Arquivo Gerado">Arquivo Gerado</option>
          <option value="Paga">Paga</option>
        </select>
      )
    },
    {
      Header: "",
      className: "text-center",
      filterable: false,
      sortable: false,
      width: 80,
      Cell: row => habilitarImpressao(row)
    }
  ];

  return (
    <main id="emitidas">
      <AlertasContext.Consumer>
        {alertas => {
          showInfoMessage = alertas.info;
          showSuccessMessage = alertas.success;
          showWarningMessage = alertas.warning;
          showErrorMessage = alertas.error;
        }}
      </AlertasContext.Consumer>
      <BlockUiContext.Consumer>
        {blockUi => {
          onLoading = blockUi.handleLoading;
        }}
      </BlockUiContext.Consumer>
      <DesmarcarComoPaga
        ref={ModalDesmarcarComoPaga}
        onClosed={handleReload}
        alternarPagamento={alternarPagamento}
      />
      <ImpressoesDetalhes
        ref={ModalDetalhes}
        value={detalhes}
        onClosed={handleReload}
      />
      <ErroImpressaoGuiasEmitidas
        ref={ModalErroImpressao}
        listErro={erroImpressao}
        onClosed={handleReload}
      />
      <EmissoesES ref={ModalImpressaoES} />
      <EmissoesExclusao
        ref={ModalEmissoesExclusao}
        value={allSelectedIds.length > 0 ? allSelectedIds : showData.filter(x => x.blSelected).map(x => x.id)}
        onClosed={handleReload}
      />
      <EmissoesExclusaoTodos
        ref={ModalEmissoesExclusaoTodos}
        value={allSelectedIds.length > 0 ? allSelectedIds : showData.map(x => x.id)}
        status={4}
        onClosed={handleReload}
      />
      <Row noGutters id="main-header">
        <Col>
        {/* 
						<Row>
							<Col className="alert alert-primary" style={{ margin: '0px 10px 10px 10px', padding: '10px', fontSize: 'small' }}>
							<strong>Conforme noticia do Portal GNRE, o serviço está indisponível hoje, 16/10/2026, das 08h30 às 18h. O serviço poderá ser restabelecido antes do horário previsto.</strong>
							</Col>
						</Row>
        */}

          <Row
            style={{
              display: "flex",
              justifyContent: "spaceBetween",
              alignItems: "center",
              flexWrap: "wrap",
              padding: "10px",
              gap: "10px"
            }}
          >
            <Col style={{ flex: "0.7 1 0%", minWidth: "100px" }}>
              <h1>Guias emitidas</h1>
            </Col>
            {/* <Col style={{ flex: '2 1 0%', 'minWidth': '100px' }}>
							<NavLink
								href="https://auditor.econeteditora.com.br/validar-login"
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								Para gerar a <b>GNRE por Apuração</b>, favor auditar o arquivo TXT através do <b>Auditor Fiscal</b>
							</NavLink>
						</Col>
						<Col style={{ flex: '1 1 0%', 'minWidth': '100px' }}>
							<NavLink
								href={urlHomo}
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								<>Verificar disponibilidade de emissão por UF </>
								<i className="fas fa-info-circle" />
							</NavLink>
						</Col> */}
          </Row>
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              // padding: "10px",
            }}
          >
            <div className="singleHeaderHeight">
              <Container id="buttons" className="p-0">
                <Row>
                  <Col xs="auto p-0">
                    <Button
                      onClick={() => acaoBotaoSelecionardesmarcrTodas()}
                      size="sm"
                      color="base-class btn-info"
                      block
                      disabled={showData.length <= 0}
                    >
                      <i className="fa fa-check-square" aria-hidden="true"></i>
                      { todasMarcadas ? " Desmarcar Todas" : " Selecionar Todas"}
                    </Button>
                  </Col>
                  <Col xs="auto p-0">
                    <Button
                      size="sm"
                      color="primary"
                      block
                      onClick={() => imprimirFiltro()}
                      disabled={
                        !isSimulacao
                          ? !showData.some(original => original.blSelected)
                          : "false"
                      }
                    >
                      <i className="fas fa-print" /> Imprimir
                    </Button>
                  </Col>
                  <Col xs="auto p-0">
                    <Button
                      data-toggle="tooltip"
                      data-placement="top"
                      data-html="true"
                      title="Gerar remessa bancária: Para habilitar a remessa bancária, é necessário selecionar, no mínimo, dois registros do mesmo emitente."
                      onClick={() => {
                        if (allSelectedIds.length > 0) {
                          // "Selecionar Todas" ativo: buscar dados completos via API com validação de CNPJ
                          onLoading(true);
                          const params = new URLSearchParams({
                            filterEmitente: filterEmitente,
                            filterUf: filterUf,
                            filterBusca: filterBusca
                          });
                          HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/RemessaBancaria/BuscarGuiasParaRemessa?${params}`)
                            .then(response => {
                              onLoading(false);
                              const resultado = response.data;
                              if (!resultado.sucesso) {
                                showWarningMessage(resultado.mensagem);
                                return;
                              }
                              const guiasFormatadas = resultado.guias.map(g => ({
                                ...g,
                                valor: g.valorTotal
                              }));
                              setValueRemessa(guiasFormatadas);
                              setTimeout(() => {
                                if (ModalRemessaBancaria.current) {
                                  ModalRemessaBancaria.current.openModal();
                                }
                              }, 0);
                            })
                            .catch(() => {
                              onLoading(false);
                              showErrorMessage("Erro ao buscar guias para remessa bancária.");
                            });
                        } else {
                          // Seleção manual por checkbox: manter comportamento atual
                          const selecionadas = showData.filter(x => x.blSelected);
                          setValueRemessa(selecionadas);
                          setTimeout(() => {
                            if (ModalRemessaBancaria.current) {
                              ModalRemessaBancaria.current.openModal();
                            }
                          }, 0);
                        }
                      }}
                      size="sm"
                      className="btn-alert"
                      block
                      disabled={
                        !isSimulacao && !isPro
                          ? validarShowRemessaBancaria(
                              showData.filter(x => x.blSelected)
                            )
                          : "false"
                      }
                    >
                      <i className="fas fa-print" /> Gerar remessa bancária
                    </Button>
                  </Col>
                  <Col xs="auto p-0">
                    <Button
                      data-toggle="tooltip"
                      data-placement="top"
                      data-html="true"
                      title="Selecionar guias para remessa: Para habilitar a seleção de guias para a remessa bancária, é necessário selecionar, no mínimo, dois registros do mesmo emitente."
                      onClick={() => ModalRemessaBancariaAvisoSelecionarTodas.current.openModal()}
                      size="sm"
                      className="btn-selectguiasall"
                      block
                      disabled={
                        !isSimulacao && !isPro
                          ? validarShowRemessaBancaria(
                              showData.filter(x => x.blSelected)
                            )
                          : "false"
                      }
                    >
                      <i className="fas fa-check" /> Remessa/Emitente/Lote
                    </Button>
                  </Col>
                  <Col xs="auto p-0">
                    <Button
                      onClick={() => ModalEmissoesExclusao.current.openModal()}
                      size="sm"
                      color={`base-class btn-danger`}
                      block
                      disabled={
                        !isSimulacao && !isPro
                          ? !showData.some(original => original.blSelected)
                          : "false"
                      }
                    >
                      <i className="fas fa-trash-alt" /> Excluir
                    </Button>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="singleHeaderHeight">
              <Container id="buttons" className="p-0">
                <Row>
                  <Col xs="auto p-0">
                    <Button 
                      className="ButtonStyleAction"
                      size="sm"
                      block
                      onClick={() => {
                        setBlFiltroAtivo(!blFiltroAtivo);
                        setFilterBusca('');
                        setFilterEmitente('');
                        setFilterUf('');
                        setFilterData('');
                        setFilterStatus('');
                        setStrBusca("");
                        handleReload(1);
                      }}
                      color="link"
                    >
                      <i className="ecoico ecoico-filtro" />
                    </Button>
                  </Col>
                  <Col xs="auto p-0">
                    <Button
                      className="ButtonStyleAction"
                      size="sm"
                      block
                      onClick={() => {
                        setBlShowPesquisaRapida(true);
                        setBlFiltroAtivo(false);
                      }}
                      color="link"
                    >
                      {strBusca ? (
                        <i className="fas fa-search-plus" />
                        ) : (
                        <i className="fas fa-search" />
                      )}
                    </Button>
                  </Col>
                </Row>
              </Container>
            </div>
          </Row>
          {blShowPesquisaRapida &&
          <Row>
            <Col
              xs="12"
              xl="12"
              className="singleHeaderHeight_newline mobile-buttons"
            >
              <PesquisaRapida
                value={strBusca}
                blShow={blShowPesquisaRapida}
                rawData={rawData}
                rawDocs={rawDocs}
                rawDocsValorTotal={rawDocsValorTotal}
                rawDocsReceita={rawDocsReceita}
                rawDocsDestinatario={rawDocsDestinatario}
                rawDocsVlPrincipal={rawDocsVlPrincipal}
                onUpdate={onUpdatePesquisaRapida}
              />
            </Col>
          </Row>
          }
        </Col>
      </Row>
      <Row noGutters>
        <Col>
          <ReactTable
            className="table-emitidas"
            ref={reactTable}
            data={showData}
            filterable={blFiltroAtivo}
            columns={columns}
            manual
            pages={Math.ceil(totalCount / pageSize)}
            page={currentPage - 1}
            showPagination={totalCount > 0}
            showPageSizeOptions={false}
            selectAll={false}
            PaginationComponent={Pagination}
            childPaginationValue={childPaginationValue}
            onPageChange={(pageIndex) => {
              handleReload(pageIndex + 1);
            }}
            onSortedChange={(newSorted) => {
              if (newSorted.length > 0) {
                setSortConfig({
                  sortBy: newSorted[0].id,
                  sortDirection: newSorted[0].desc ? 'desc' : 'asc'
                });
                handleReload(1);
              }
            }}
            onFilteredChange={(filtered) => {
              let newFilterEmitente = '';
              let newFilterUf = '';
              let newFilterData = '';
              let newFilterStatus = '';
              filtered.forEach(f => {
                if (f.id === 'razaoSocialEmissor') newFilterEmitente = f.value;
                if (f.id === 'uf') newFilterUf = f.value;
                if (f.id === 'data' && f.value) {
                  // input type="date" retorna yyyy-MM-dd, converter pra dd/MM/yyyy
                  const parts = f.value.split('-');
                  if (parts.length === 3) newFilterData = `${parts[2]}/${parts[1]}/${parts[0]}`;
                }
                if (f.id === 'status') newFilterStatus = f.value;
              });
              setFilterEmitente(newFilterEmitente);
              setFilterUf(newFilterUf);
              setFilterData(newFilterData);
              setFilterStatus(newFilterStatus);

              if (debounceTimer.current) clearTimeout(debounceTimer.current);
              debounceTimer.current = setTimeout(() => {
                handleReload(1, { filterEmitente: newFilterEmitente, filterUf: newFilterUf, filterData: newFilterData, filterStatus: newFilterStatus });
              }, 500);
            }}
            SubComponent={row => renderDocumentosFiscais(row)}
            pageSize={pageSize}
            onPageSizeChange={(newSize) => {
              setPageSize(newSize);
              handleReload(1, { pageSize: newSize });
            }}
            strTableInfo={`${totalCount} Guias`}
          />
        </Col>
      </Row>
      <RemessaBancariaAvisoSelecionarTodas 
        ref={ModalRemessaBancariaAvisoSelecionarTodas}
        value={showData.filter(x => x.blSelected)}
        onAccept={onAcceptSelected}
        onClosed={handleReload}
      />
      <RemessaBancaria
        ref={ModalRemessaBancaria}
        value={valueRemessa}
        onClosed={handleReload}
      />
      <AvisoSelecionarTodas
        ref={ModalAvisoSelecionarTodas}
        isOpen={true}
        intQuantidade={totalCount}
        onClosed={handleReload}
        onAccept={SelecionarTodasGuias}
      />
    </main>
  );
}

export default withRouter(Emitidas);
